<template>
  <div 
    class="d-flex flex-column" 
    style="max-width: 150px;"
    v-click-outside="hideDropdown">
    <label class="text-saka-grey" style="margin-bottom: -.25em">
      <small><b>{{ label }}</b></small></label>
      <!-- <select class="bg-saka-grey text-saka-grey py-1 px-2 rounded" @input="$emit('input', $event.target.value !== '' ? $event.target.value : null)">
        <option :value="null"></option>
        <option
          v-for="item in items"
          :value="item"
          :key="item"
          class="p-2"
          :disabled="disabledItems.includes(item)"
        >
          <div class="d-flex justify-content-between"><span>{{ item }}</span><span class="text-success">*</span></div>
        </option>
      </select> -->
    <div 
      class="bg-saka-grey text-light py-1 px-2 rounded d-flex justify-content-between shadow-sm cursor-pointer"
      @click="isOpen = !isOpen"
    >
      <span>{{ value }}</span>
      <span>
        <small>
          <i class="fas" :class="{
            'fa-chevron-up': isOpen,
            'fa-chevron-down': !isOpen
          }">
          </i>
        </small>
      </span>
    </div>

    <div
     v-if="isOpen"
     class="d-flex flex-column w-100 bg-light text-saka-grey options border-2 border-saka-grey shadow-sm" style="max-height: 11em; position: absolute; z-index: 10; margin-top: 3.25em; overflow-y: auto; max-width: 150px;">
      <div class="option px-1 py-1 mx-1 option-unselect" @click.prevent.stop="handleSetValue({ value: null })"><em>{{ $i18n.locale === 'de'? 'keine Auswahl' : 'no selection'}}</em></div>
      <div
        v-for="item in items"
        class="option px-1 py-1 mx-1 d-flex flex-row justify-content-between"
        :key="item"
        @click.prevent.stop="!disabledItems.includes(item) ? handleSetValue({ value: item }) : ''"
        :class="{
          'option-disabled cursor-disabled': disabledItems.includes(item)
        }"
        >
        <span>{{ item }}</span>
        <span 
          class="text-saka-green"
          v-if="value === item"
        >
          <small><i class="fas fa-check"></i></small>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    disabledItems: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: null
    },
    
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  data () {
    return {
      isOpen: false
    }
  },
  directives: {
    ClickOutside
  },
  methods: {
    hideDropdown () {
      this.isOpen = false
    },
    handleSetValue ({ value }) {
      this.$emit('input', value)
      this.hideDropdown()
    }
  }
}
</script>

<style>
.option {
  background-color: white;
  border-bottom: 0.5px solid lightgray;
}

.option:hover {
  background-color: whitesmoke;
  cursor: pointer;
}

.cursor-disabled {
  cursor: not-allowed !important;
}

.option-disabled {
  color:rgb(224, 224, 224)
}

.border-saka-grey {
  border-color: rgb(157, 157, 156);
}

.cursor-pointer {
  cursor: pointer;
}

.text-saka-green {
  color: #008040;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
     /* IE10+ CSS styles go here */
  .options {
    margin-top: 0em !important; 
  }
}
</style>